import React from "react";
import { Link } from "react-router";
import { Facebook, Instagram, Linkedin } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#181817] text-primary-foreground">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          <div className="lg:col-span-2">
            <Link to="/" aria-label="Colour Club Printers — go to homepage" className="mb-4 inline-flex flex-col gap-3 outline-none focus-visible:ring-2 focus-visible:ring-white/40 focus-visible:ring-offset-2 focus-visible:ring-offset-[#181817] rounded-md">
              <img
                src="/logofooter.png"
                alt="Colour Club Printers logo"
                className="h-10 w-auto max-w-[200px] object-contain object-left"
                width={200}
                height={40}
                decoding="async"
              />
              <div className="flex flex-col">
                <span className="text-lg font-semibold">Colour Club Printers</span>
                <span className="text-xs text-primary-foreground/90">Paper Printing Services</span>
              </div>
            </Link>
            <p className="text-sm text-primary-foreground/90 mb-4 max-w-md">
              Premium packaging and printing solutions for global brands. FSC certified, ISO 9001 compliant, and Sedex registered.
            </p>
            <div className="text-sm text-primary-foreground/90 space-y-2 mb-6 max-w-md">
              <div className="pb-2 text-xs text-primary-foreground/70">
                Colour Club Printers is a commercial brand operated by Paper Printing Services, Faisalabad, Pakistan. Paper Printing Services is the legal contracting, invoicing and FSC-certified entity.
              </div>
              <p className="text-balance">
                Madina Market, Sugar Mor, Near PSO Pump, Sheikhupura Road, Nishatabad, Faisalabad, Pakistan
              </p>
              <p>
                <a href="mailto:info@colourclubprinters.com" className="hover:text-white transition-colors">
                  info@colourclubprinters.com
                </a>
                <span className="mx-2 text-primary-foreground/90">·</span>
                <a href="mailto:colourclubprinter@gmail.com" className="hover:text-white transition-colors">
                  colourclubprinter@gmail.com
                </a>
              </p>
              <p className="flex flex-wrap gap-x-2 gap-y-1">
                <a href="tel:+92418750239" className="hover:text-white transition-colors">
                  +92-41-8750239
                </a>
                <span className="text-primary-foreground/90">|</span>
                <a href="tel:+92418850239" className="hover:text-white transition-colors">
                  +92-41-8850239
                </a>
                <span className="text-primary-foreground/80">|</span>
                <a href="tel:+923008666239" className="hover:text-white transition-colors">
                  +92-300-8666239
                </a>
              </p>
            </div>
            <div className="flex space-x-4">
              <a href="http://facebook.com/colourclubprinters" target="_blank" rel="noopener noreferrer" aria-label="Colour Club Printers on Facebook" className="size-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors">
                <Facebook className="size-5" aria-hidden />
              </a>
              <a href="https://www.instagram.com/colourclubprinters/" target="_blank" rel="noopener noreferrer" aria-label="Colour Club Printers on Instagram" className="size-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors">
                <Instagram className="size-5" aria-hidden />
              </a>
              <a href="https://www.linkedin.com/company/colour-club-printers" target="_blank" rel="noopener noreferrer" aria-label="Colour Club Printers on LinkedIn" className="size-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-white/20 transition-colors">
                <Linkedin className="size-5" aria-hidden />
              </a>
            </div>
          </div>

          <div>
            <h3 className="mb-4 font-semibold text-primary-foreground">Products</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/90">
              <li><Link to="/products/textile-home-packaging" className="hover:text-white transition-colors">Textile & Home Packaging</Link></li>
              <li><Link to="/products/garment-packaging" className="hover:text-white transition-colors">Garment Packaging</Link></li>
              <li><Link to="/products/luxury-packaging" className="hover:text-white transition-colors">Luxury Packaging</Link></li>
              <li><Link to="/products/labels-stickers" className="hover:text-white transition-colors">Labels & Stickers</Link></li>
              <li><Link to="/products/custom-packaging" className="hover:text-white transition-colors">Custom Packaging</Link></li>
              <li><Link to="/products/retail-display-packaging" className="hover:text-white transition-colors">Retail & Display Packaging</Link></li>
              <li><Link to="/products/eco-friendly-packaging" className="hover:text-white transition-colors">Eco-Friendly Packaging</Link></li>
              <li><Link to="/products/business-print-materials" className="hover:text-white transition-colors">Business Print Materials</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-semibold text-primary-foreground">Company</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/90">
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/sustainability" className="hover:text-white transition-colors">Sustainability</Link></li>
              <li><Link to="/facility" className="hover:text-white transition-colors">Our Facility</Link></li>
              <li><Link to="/process" className="hover:text-white transition-colors">Our Process</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-semibold text-primary-foreground">Resources</h3>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li><Link to="/services" className="hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/industries" className="hover:text-white transition-colors">Industries</Link></li>
              <li><Link to="/options" className="hover:text-white transition-colors">Options Library</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/blog" className="hover:text-white transition-colors">Blog</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-primary-foreground/80">
          <p className="text-primary-foreground/90">© 2026 Paper Printing Services. Colour Club Printers is its commercial brand.</p>
          <div className="flex space-x-6 mt-4 md:mt-0 flex-wrap justify-end gap-y-2">
            <Link to="/privacy-policy" className="text-primary-foreground/90 hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-primary-foreground/90 hover:text-white transition-colors">Terms of Service</Link>
            <Link to="/cookie-policy" className="text-primary-foreground/90 hover:text-white transition-colors">Cookie Policy</Link>
            <Link to="/legal-and-certifications" className="text-primary-foreground/90 hover:text-white transition-colors">Legal & Certifications</Link>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap justify-center sm:justify-start gap-4 text-xs text-primary-foreground/90">
          <span className="px-3 py-1 bg-white/5 rounded-full">FSC Certified</span>
          <span className="px-3 py-1 bg-white/5 rounded-full">ISO 9001</span>
          <span className="px-3 py-1 bg-white/5 rounded-full">Sedex Member</span>
          <span className="px-3 py-1 bg-white/5 rounded-full">UK · EU · USA</span>
        </div>
      </div>
    </footer>
  );
}
